import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  createBranchAction,
  updateBranchAction,
} from "../../../store/actions/BranchAction";
import { showErrorAlert } from "../../../services/ErrorHandlingService";
import Loader from "../Common/Loader";

const AddBranch = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();
  const branch = location.state?.branch || null;
  const returnTo = location.state?.returnTo || null;

  // Form State
  const [form, setForm] = useState({
    branch_name: "",
    branch_code: "",
    branch_location: "",
    branch_mobile: "",
    branch_email: "",
    branch_status: "Active",
  });

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [errors, setErrors] = useState({});


  // Status options
  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  // Prefill form if in edit mode
  useEffect(() => {
    if (branch) {
      setFetching(true);
      setErrors("");
      setForm({
        // branch_name: branch.branch_name || [],
        branch_name: branch.branch_name || "",

        branch_code: branch.branch_code || "",
        branch_location: branch.branch_location || "",
        branch_mobile: branch.branch_mobile || "",
        branch_email: branch.branch_email || "",
        branch_status: branch.branch_status || "",
      });
      setFetching(false);
    }
  }, [branch]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  
    // Remove error for that field on change
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };
  
  // Handle status change
  const handleStatusChange = (selectedOption) => {
    setForm({ ...form, branch_status: selectedOption?.value || "" });
  
    setErrors((prevErrors) => ({
      ...prevErrors,
      branch_status: "",
    }));
  };
  

  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(phone.replace(/\D/g, ""));
  };

  // Validate form
  const validate = () => {
    const newErrors = {};
    if (!form.branch_name.trim()) {
      newErrors.branch_name = "Enter branch name";
    } else if (!/^[A-Za-z\s]+$/.test(form.branch_name.trim())) {
      newErrors.branch_name = "Branch name should contain only letters";
    }
    
    if (!form.branch_code.trim()) {
      newErrors.branch_code = "Branch Code is required";
    } else if (!/^[a-zA-Z0-9]+$/.test(form.branch_code)) {
      newErrors.medicineCode = "Branch Code must be alphanumeric";
    }
    if (!form.branch_location) newErrors.branch_location = "Branch Location is required";

    if (!form.branch_mobile.trim()) {
      newErrors.branch_mobile = "Mobile Number is required";
    } else if (!validatePhone(form.branch_mobile)) {
      newErrors.branch_mobile = "Mobile Number must be 10 digits";
    }
    if (!form.branch_email.trim()) {
      newErrors.branch_email = "Email Address is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.branch_email)) {
      newErrors.branch_email = "Enter a valid email address";
    }
    if (!form.branch_status) newErrors.branch_status = "Status is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors("");

    if (!validate()) {
      setLoading(false);
      return;
    }
    try {
      if (id) {
        await dispatch(updateBranchAction(form, id, navigate));
      } else {
        await dispatch(createBranchAction(form));
      }

      navigate("/branches", {
        state: returnTo ? { ...returnTo } : undefined,
      });
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }

  };
  if (fetching) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <Loader size="lg" />
      </div>
    );
  }


  return (
    <div className="row">
      <div className="col-xl-12">
      {/* <div className="d-flex justify-content-end p-3">
            <Link to="/branch">
              <Button variant="primary">Back</Button>
            </Link>
          </div> */}
        <div className="card">
          <div className="card-body">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "20px",
              }}
            >
              <Link to="/branches" className="btn btn-link">
                <Button variant="primary">Back</Button>
              </Link>
            </div>
            {typeof errors === "string" && <div className="text-danger mb-2">{errors}</div>}
            {/* {loading && (
              <div className="text-center">
                <Loader size="md" />
              </div>
            )} */}
            <h4 className="mb-4">{id ? "" : ""}</h4>
            <form onSubmit={handleSubmit}>
              {/* Branch Names (Multi-select) */}
              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Branch Name</label>
                  <span style={{ color: "red" }}>*</span>
                  <input
                    type="text"
                    className="form-control"
                    name="branch_name"
                    value={form.branch_name}
                    onChange={handleChange}
                    placeholder="Enter Name"
                  />
                  {errors.branch_name && <small className="text-danger">{errors.branch_name}</small>}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Branch Code
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="branch_code"
                    pattern="[a-zA-Z0-9]+"
                    value={form.branch_code}
                    onChange={handleChange}
                    placeholder="Enter Code"
                  />
                  {errors.branch_code && <small className="text-danger">{errors.branch_code}</small>}
                </div>



              </div>

              {/* Mobile and Email */}
              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Branch Location
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="branch_location"
                    value={form.branch_location}
                    onChange={handleChange}
                    placeholder="Enter Location"
                  />
                  {errors.branch_location && <small className="text-danger">{errors.branch_location}</small>}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Mobile Number
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    name="branch_mobile"
                    value={form.branch_mobile}
                    onChange={handleChange}
                    placeholder="Enter Mobile"
                    maxLength="10"
                  />
                  {errors.branch_mobile && <small className="text-danger">{errors.branch_mobile}</small>}
                </div>

              </div>

              {/* Status */}
              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Email Address
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="branch_email"
                    value={form.branch_email}
                    onChange={handleChange}
                    placeholder="Enter Email"
                  />
                  {errors.branch_email && <small className="text-danger">{errors.branch_email}</small>}
                </div>

                <div className="col-xl-6 mb-3">
                  <label className="form-label">Status
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    options={statusOptions}
                    value={statusOptions.find((opt) => opt.value === form.branch_status)}
                    onChange={handleStatusChange}
                    placeholder="Select Status"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                    }}
                    isClearable
                  />
                  {errors.branch_status && <small className="text-danger">{errors.branch_status}</small>}
                </div>
              </div>

              {/* Action Buttons */}
              <button
                type="submit"
                className="btn btn-primary me-2"
                disabled={loading || fetching}
              >
                {loading ? (
                  <>
                    <Loader size="sm" />
                    <span className="ms-2">Submitting...</span>
                  </>
                ) : (
                  <>{id ? "Update Branch" : "Add Branch"}</>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBranch;